import React from 'react';

import { ReactComponent as InfoIcon } from '../../assets/info.svg';

import { ConsentTypeContactDanish } from '../../helpers/EnumsDanish';
import GenderToDanish from '../../helpers/GenderDanish';
import OwnerConsentHistory from './OwnerConsentHistory';
import ConsentAuxFieldsRow from '../ConsentAuxFieldsRow';


type HeaderProps = {
    consent: any,
    consentTypeImages: any
}

function OwnerConsent(props: HeaderProps) {
    const { consent, consentTypeImages } = props;

    return (
        <div className="content">
            <div className="inner">
                <div className="section">

                    <div className="col-3 col-md-12">
                        <label>Kampagne</label>
                        { consent.campaignTitle?.length > 25 ?
                            <p>{ consent.campaignTitle?.substring(0, 25) }...
                                <span className="with-tipbox">
                                    &nbsp;<InfoIcon />
                                    <span className="tipbox right">{ consent.campaignTitle }</span>
                                </span>
                            </p>
                        :
                            <p>{ consent.campaignTitle }</p>
                        }
                    </div>
                    <div className="col-3 col-md-12">
                        <label>Samtykke Afgivet</label>
                        <p>{ new Date(consent.consentDateTime).toLocaleString('en-DK').replace(',', '') }</p>
                    </div>
                    <div className="col-3 col-md-12">
                        <div className="icons">
                            { consent.consentTypes.map((ct: number, index: number) => (
                                <div key={index} className="icon" title={ ConsentTypeContactDanish[ct] }>{ consentTypeImages[ct]}</div>
                            ))}
                        </div>
                    </div>
                    <div className="col-3 col-md-12">
        				<label>Status</label>
                        <p className="status">
                            { consent.isRevoked ?  'Tilbagekaldt' : 'Aktiv' }
                        </p>
       				</div>
                </div>

                <div className="section small-info">
                    <div className="col-3 col-md-12">
                        <label>Fornavn</label>
                        <p>{consent.firstname}</p>
                        <label>E-mail</label>
                        <p>{consent.email}&nbsp;</p>
                        <label>F&oslash;dseldato</label>
                        <p>{ new Date(consent.dateOfBirth).toLocaleDateString() }&nbsp;</p>
                        <ConsentAuxFieldsRow column={0} auxFields={consent.consentAuxiliaryFieldTypes} />
                    </div>
                    <div className="col-3 col-md-12">
                        <label>Efternavn</label>
                        <p>{consent.lastname}</p>
                        <label>Adresse</label>
                        <p>{consent.address}&nbsp;</p>
                        <label>K&oslash;n</label>
                        <p><GenderToDanish gender={consent.gender} /></p>
                        <ConsentAuxFieldsRow column={1} auxFields={consent.consentAuxiliaryFieldTypes} />
                    </div>
                    <div className="col-3 col-md-12">
                        <label>Mobil</label>
                        <p>{consent.mobilePhone}</p>
                        <label>Postnr.</label>
                        <p>{consent.postalCode}&nbsp;</p>
                        <label>Website</label>
                        <p><span className="with-tipbox">
                                <a href={consent.signupURL} target="_blank" rel="noreferrer">Link</a>
                                <span className="tipbox small-right">{consent.signupURL}</span>
                            </span></p>&nbsp;
                        <ConsentAuxFieldsRow column={2} auxFields={consent.consentAuxiliaryFieldTypes} />
                    </div>
                    <div className="col-3 col-md-12">
                        <label>Fastnet</label>
                        <p>{consent.phone}&nbsp;</p>
                        <label>By</label>
                        <p>{consent.city}&nbsp;</p>
                        <label>IP-adresse</label>
                        <p>{consent.signupIP}&nbsp;</p>
                        <ConsentAuxFieldsRow column={3} auxFields={consent.consentAuxiliaryFieldTypes} />
                    </div>
                </div>


                {   (consent.screenshotUrl1 || consent.screenshotUrl2 ||consent.videoUrl) &&
                    <div className="section">
                        <div className="btn-container">
                            { consent.screenshotUrl1 !== null && consent.screenshotUrl1 !== '' &&
                                <a href={consent.screenshotUrl1} target="_blank" rel="noopener noreferrer" className="btn btn-transparent">Screenshot af kampagne</a>
                            }
                            { consent.screenshotUrl2  &&
                                <a href={consent.screenshotUrl2} target="_blank" rel="noopener noreferrer" className="btn btn-transparent">Screenshot af kampagne</a>
                            }
                            { consent.videoUrl &&
                                <a href={consent.videoUrl} target="_blank" rel="noopener noreferrer" className="btn btn-transparent">Videooptagelse af kampagne</a>
                            }
                        </div>
                    </div>
                }

                <div className="bottom">
                    <OwnerConsentHistory hist={consent.consentHistories} />
                </div>
            </div>
        </div>
    )
}

export default OwnerConsent;
